import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const TAURI_SCRAPER_EVENT_EMIT_REJECTION =
  'event.emit not allowed on window "catawiki-scraper", webview "catawiki-scraper"';

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

const isExpectedTauriScraperEventEmitRejection = (
  message: unknown
): boolean => {
  const normalizedMessage = toNormalizedMessage(message);

  return (
    normalizedMessage?.includes(TAURI_SCRAPER_EVENT_EMIT_REJECTION) === true
  );
};

export const nonErrorTauriScraperEventEmitUnhandledRejectionRule: ClientSentryIgnoreRule =
  {
    id: 'non-error-tauri-scraper-event-emit-unhandled-rejection',
    references: ['FTR-3191'],
    reason:
      'Known external Tauri scraper webview rejection without usable seller-ui stack/app-frame context',
    matches: (context) => {
      if (context.firstExceptionType !== 'UnhandledRejection') {
        return false;
      }

      if (hasActionableContext(context)) {
        return false;
      }

      return (
        isExpectedTauriScraperEventEmitRejection(context.serializedMessage) ||
        isExpectedTauriScraperEventEmitRejection(
          context.originalExceptionMessage
        )
      );
    },
  };
